import { useDispatch, useSelector } from 'react-redux'
import PageTitle from '../fragments/PageTitle'
import classes from './History.module.css'
import { historyActions } from '../../store/history'
import { useHistoryList } from '../../lib/hooks'
// import Pagination from './pagination/Pagination'
import HistoryRow from './HistoryRow'
import HistoryHeader from './HistoryHeader'
import HistoryFilters from './HistoryFilters'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '../common/Button'
import MockRows from '../mock/MockRows'
import { history_table_header_cells } from '../../assets/data'
import Pagination from '../work_queues/pages/pagination/Pagination'


export default function History({ caseIdFromDetails }) {
    const dispatch = useDispatch()
    const { caseId } = useParams()


    const navigate = useNavigate();
    const loading = useSelector(state => state.history.loading)
    const snapshot = useSelector(state => state.history.snapshotData)
    const patientsList =  useSelector(state => state.history.currentpagedata)

    let caseID = caseId || caseIdFromDetails

    // get the referrals list from the hook 
    useHistoryList(caseID, caseIdFromDetails)

    const setPatients = (patients) => {
        // setPatientsList(patients)
        dispatch(historyActions.setCurrentPageData(patients))
        dispatch(historyActions.setSnapshotData(patients)) // this is a snapshot to show because a loading page is bad! :))

    }

    function viewAllHistory() {
        // dispatch(historyActions.setRefreshApi())
        navigate('/history', {replace: true})
    }

    // console.log('patientsList:: ', patientsList)

    return <>
        <div className={`${classes.header_box} ${caseIdFromDetails ? classes.header_tab : ''}`}>
            <div className='flex-container'>
                <PageTitle isContainer={caseIdFromDetails ? false : true} isInTab={caseIdFromDetails}>
                    History    
                </PageTitle>  
                {caseId && <Button btnStyle={'btn_dark'} click={viewAllHistory}>View all history</Button>}
            </div>  
            
            <HistoryFilters showNgFilter={!caseIdFromDetails} />
        </div>
        <div className={`${caseIdFromDetails ? classes.body_container : ''}`}>
            <div className={`${classes.content_wrapper} ${caseIdFromDetails ? classes.body_container_inner : ''}`}>
                <table>
                    <HistoryHeader isInTab={caseIdFromDetails} />
                    {loading && !snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        <MockRows numberOfRows={history_table_header_cells.length}/>
                    </tbody>}
                    {loading && snapshot && <tbody className={`${classes.table_body} ${classes.table_body_loading}`}>
                        {snapshot.data.map((item, index) => (
                            <HistoryRow key={item.id} data={item} index={index} classes={classes} isInTab={caseIdFromDetails}/>
                        ))}
                    </tbody>}
                    {!loading && patientsList && patientsList.data && <tbody>
                        {patientsList.data.map((item, index) => (
                            <HistoryRow key={item.id} data={item} index={index} classes={classes} isInTab={caseIdFromDetails}/>
                        ))}    
                    </tbody>}   
                    {!loading && !patientsList && <tbody>
                        <tr>
                            <td colSpan={history_table_header_cells.length}>No items found</td>    
                        </tr> 
                    </tbody>}          
                </table>                
            </div>

            {patientsList && patientsList.meta && <div className={`${classes.pagination_container} ${caseIdFromDetails ? classes.in_tab : ''}`}>
                {patientsList  && <Pagination data={patientsList} list={setPatients} apiType='history' hidePerPage={true} />}
            </div>}
        </div>
    </>
}